export default __webpack_public_path__ + "static/media/waffle_white.ac9ddbc0.svg";